import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    templateUrl: '../../../template/noop.template.html',
    standalone: false
})
export class DecoderLayoutComponent implements OnInit {
  @Input() data: any;
  @Output() eventEmit: EventEmitter<string> = new EventEmitter<string>();
  defaultSSString = '';
  placeholderString = '*^v?2a%(#$@/PE%!aV29q01';
  errorMsg = '';
  constructor() {}

  ngOnInit() {
    if (this.data) {
      if (this.data.errorMsg) {
        this.errorMsg = this.data.errorMsg;
      }
    }
  }

  closeSecretSquirrelPopup = (eve) => {
    //console.log('Close Pop up');
    let emitObj: any = {};
    emitObj.currentLanguage = this.data.currentLanguage;
    emitObj.secretStr = this.data.secretStr;
    emitObj.errorMsg = this.data.errorMsg;
    emitObj.action = 'close';
    this.eventEmit.emit(emitObj);
  };

  onSSInputFocus = (eve) => {
    this.errorMsg = '';
    if (this.defaultSSString == '') {
      this.placeholderString = '';
    }
  };

  onDecodeClick = (eve) => {
    let emitObj: any = {};
    emitObj.currentLanguage = this.data.currentLanguage;
    emitObj.secretStr = this.data.secretStr;
    emitObj.errorMsg = this.data.errorMsg;
    if (this.defaultSSString != '') {
      emitObj.action = this.defaultSSString;
      this.eventEmit.emit(emitObj);
    }
  };
}
